export const consoleNoop = {};
for (let prop in window.console) {
  consoleNoop[prop] = () => {};
}


export function iOSScrollFix() {
  let scrollfixers = $('.ios-scrollfix'),
      body = $(document.body);
  
  scrollfixers.css("pointer-events","none");
  
  body.on('touchstart', e => {
    scrollfixers.css("pointer-events","auto");
  });
  body.on('touchmove', e => {
    scrollfixers.css("pointer-events","none");
  });
  body.on('touchend', e => {
    setTimeout(() => {
      scrollfixers.css("pointer-events", "none");
    }, 0);
  });
}


export class ResponsiveBreakpoint {
  constructor(width, height) {
    this.width = width;
    this.height = height;
  }
  
  lesser() { return this.lesserW() || this.lesserH(); }
  lesserW() { return window.innerWidth <= this.width; }
  lesserH() { return window.innerHeight <= this.height; }
  
  greater() { return this.greaterW() || this.greaterH(); }
  greaterW() { return window.innerWidth > this.width; }
  greaterH() { return window.innerHeight > this.height; }
}

export const BrowserDetect = {
  firefox: function() {
    if (/\sFirefox\//.test(navigator.userAgent)) {
      $(document.documentElement).addClass("is-firefox");
      return true;
    }
    $(document.documentElement).addClass("not-firefox");
    return false;
  },
  safari: function() {
    if (/Version\/[.\d]+\sSafari\//.test(navigator.userAgent)) {
      $(document.documentElement).addClass("is-safari");
      return true;
    }
    $(document.documentElement).addClass("not-safari");
    return false;
  },
  edge: function() {
    if (/\sEdge\//.test(navigator.userAgent)) {
      $(document.documentElement).addClass("is-edge");
      return true;
    }
    $(document.documentElement).addClass("not-edge");
    return false;
  },
  ie: function() {
    if (/\sTrident\//.test(navigator.userAgent)) {
      $(document.documentElement).addClass("is-ie");
      return true;
    }
    $(document.documentElement).addClass("not-ie");
    return false;
  }
};

export function ieShims() {
  if (typeof Number.parseInt === "undefined") Number.parseInt = parseInt;
  if (typeof Number.parseFloat === "undefined") Number.parseFloat = parseFloat;
}


let responsive = {
  small: () => window.innerWidth <= 640,
  medium: () => window.innerWidth <= 900,
  average: () => window.innerWidth <= 1200
};